<template>
<div id="contribuciones_grafico" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Reportes de Contribuciones e Incrementables" class="elevation-1 px-5 py-3" >
                    <v-card-text>
                        <v-card-title>
                            <span class="headline" ></span>
                        </v-card-title>
                        <v-form ref="formws" lazy-validation>
                            <v-container grid-list-md text-xs-center>
                                <v-row row wrap>
                                    <v-col sm="4" md="4" lg="4" >
                                        <v-autocomplete v-model="model.reporte_url" :items="list_reportesws" :hide-no-data="true" :return-object="false" item-text="reporte" item-value="url" label="Tipo de Reporte" @change="setNombreReporteWS()" :rules="[rules.required]" >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4" >
                                        <v-autocomplete v-model="model.anio_inicial" :items="anios" :hide-no-data="true" 
                                            :return-object="false"  label="Año Inicial" :rules="[rules.required]">
                                        </v-autocomplete>                                        
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4" >
                                        <v-autocomplete v-model="model.anio_final" :items="anios" :hide-no-data="true" 
                                            :return-object="false"  label="Año Final" :rules="[rules.required, validaAnio]">
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-layout row wrap>
                                    <v-flex sm3 m3 l3>
                                        <p class="text-left font-weight-bold" >Tipo de Operación</p>
                                        <v-switch color="primary" label="Importación" v-model="model.opc_impo" value="1" :rules="[verificaTipoOperacion]" ></v-switch>
                                    </v-flex>
                                    <v-flex sm3 m3 l3>
                                        <p class="text-left font-weight-bold" >&nbsp;</p>
                                        <v-switch color="primary" label="Exportación" value="1" v-model="model.opc_expo" ></v-switch>
                                    </v-flex>                                
                                    <v-flex sm4 m4 l4>
                                        <p class="text-left font-weight-bold" >&nbsp;</p>
                                        <v-switch color="primary" label="Incluir contribuciones de rectificación" value="1" v-model="model.contribuciones_rectificacion" ></v-switch>
                                    </v-flex>
                                </v-layout>                                
                                <v-card-text>
                                        <v-container grid-list-md text-xs-center>
                                            <span style="font-size:15px;" ><strong>Tipo de Pedimento</strong></span>
                                            <v-row no-gutters dense style="margin-bottom: -35px;" >
                                                <v-col cols=3>
                                                    <v-checkbox color="blue" v-model="model.tipos_pedimento" label="1 - PEDIMENTO" value="1" :rules="[verificaTiposPedimento]" ></v-checkbox>
                                                </v-col>
                                                <v-col cols=3>
                                                    <v-checkbox color="blue" v-model="model.tipos_pedimento" label="2 - PEDIMENTO RECTIFICADO" value="2" ></v-checkbox>
                                                </v-col>
                                                <v-col cols=3></v-col>
                                                <v-col cols=3></v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                    <br/>
                                    <div>&nbsp;</div>
                                    <v-card-text>
                                        <v-expansion-panels hover>
                                            <v-expansion-panel>
                                                <v-expansion-panel-header style="font-weight:bold!important;" >Apéndice 12: Contribuciones e Incrementables&nbsp;&nbsp;<span style="font-size:12px!important;color:#ff5252!important" v-show="validaContribucion" >Seleccione una Contribución</span></v-expansion-panel-header>
                                                <v-expansion-panel-content style="margin-top: -25px;" >
                                                    <v-checkbox v-model="selecciona_todo12" label="Seleccionar Todo" @change="seleccionaTodo12()" ></v-checkbox>
                                                    <br/>
                                                    <v-row no-gutters dense>
                                                        <v-col cols=3 v-for="(forma, index) in arr_contribuciones" :key="'contri'+index" >

                                                        <v-checkbox v-model="model.contribuciones" :label="forma.nombregrupo" :value="forma.clave"
                                                        :rules="index==0?[verificaContribuciones]:[]" >
                                                        </v-checkbox>

                                                        </v-col>
                                                    </v-row>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                            
                                            <v-expansion-panel>
                                                <v-expansion-panel-header style="font-weight:bold!important;" >Apéndice 13: Formas de Pago &nbsp;&nbsp;<span style="font-size:12px!important;color:#ff5252!important" v-show="validaForma" >Seleccione una Forma de Pago</span></v-expansion-panel-header>
                                                <v-expansion-panel-content style="margin-top: -25px;" >
                                                    <v-checkbox v-model="selecciona_todo13" label="Seleccionar Todo" @change="seleccionaTodo13()" ></v-checkbox>
                                                     <br/>
                                                    <v-row no-gutters dense>
                                                        <v-col cols=3 v-for="(forma, index) in arr_formas_pago" :key="'formas'+index" >
                                                            <v-checkbox color="purple" v-model="model.formas_pago" :label="forma.clave+' - '+forma.descripcion" :value="forma.clave" :rules="index==0?[verificaFormasPago]:[]" ></v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-card-text>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn color="success" @click="generar_reporte_sqs_ws" >
                            <v-icon>done</v-icon>Generar Reporte WS
                        </v-btn>
                    </v-card-actions>

                    <v-card-text>
                        <v-refresh-button :funcion="cargarReportesWS" />
                        <v-client-table ref="vuetablews" :data="datosws" :columns="columns" :options="options" class="elevation-2 pa-2" >
                            <template slot="noResults" >
                                <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                            </template>

                            <template slot="actions" slot-scope="props" >
                                <v-btn text icon color="success" title="Ver Gráfica" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " :to="'/graficas/detalle_grafica/'+props.row.id" >
                                    <v-icon dark>trending_up</v-icon>
                                </v-btn>
                                <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                    <v-icon dark>delete</v-icon>
                                </v-btn>
                            </template>
                        </v-client-table>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
    
</div>
</template>

<script>

import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
    data: () => ({
        print:true,
        datos_anios:[],
        modal:false,
        anios:[],
        dialog1: false,
        lista_filtrada: [],
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Reportes",
                disabled: true,
                to: ""
            },
            {
                text: "Reportes de Contribuciones e Incrementables",
                disabled: true,
                to: ""
            }
        ],
        permisoEliminar: false,
        fab: false,
        datosws: [],
        validaContribucion:false,
        validaForma:false,
        selecciona_todo12: false,
        selecciona_todo13: false,
        arr_formas_pago: [],
        arr_contribuciones: [],

        columns: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
        options: {
            filterable: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
            sortable: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

            headings: {
                id:"No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",
                criterio: "Criterio de Búsqueda",
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Descargar"
            }
        },
        
        show_loading: true,

        list_reportesws: [
            {
                "reporte": "Contribuciones DS",
                "url": "/reportes_ds/contribuciones_grafica_ds/"
            },
            {
                "reporte": "Contribuciones WS",
                "url": "/reportes_ws/contribuciones_grafica_ws/"
            },
        ],

        model: {
            rfc: "",
            usuario: "",
            anio_inicial: "",
            anio_final: "",
            opc_impo: 0,
            opc_expo: 0,
            opc_descripcion: 0,
            contribuciones_rectificacion: 0,
            reporte_url: "",
            nombre_reporte: "",
            tipo: "Contribuciones_Grafica",
            contribuciones: [],
            formas_pago: [],
            tipos_pedimento: [],            
        },
        menu1ws: false,
        menu2ws: false,
        rules: {
            required: v => !!v || "Este campo es requerido",
            numeric: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        }, 
       
    }),

    methods: {     
        validaAnio: function(){
            try {
                var a_inicial = parseInt(this.model.anio_inicial);
                var a_final = parseInt(this.model.anio_final);
                if(a_final < a_inicial)
                    return "Año final debe ser mayor al inicial";
                else if (Math.abs(a_final - a_inicial) >= 5)
                    return "Se puede consultar máximo 5 años";    
                return true;
            } catch (error) {
                console.log(error);
                return true;
            }
                        
        },
        verificaTipoOperacion: function () {
            if (this.model.opc_impo != 1 && this.model.opc_expo != 1) {
                return "Seleccione al menos un tipo de operación";
            }
            return true;
        },
        verificaTiposPedimento: function(){
            if (this.model.tipos_pedimento.length == 0)
                return "Seleccione un Tipo";
            else
                return true;
        },
        verificaFormasPago: function(){
            if (this.model.formas_pago.length == 0){
                this.validaForma = true;
                return "Seleccione una Forma";
            } else {
                this.validaForma = false;
                return true;
            }
        },
        verificaContribuciones: function(){
            if (this.model.contribuciones.length == 0){
                this.validaContribucion = true;
                return "Seleccione una Contribución";
            } else {
                this.validaContribucion = false;
                return true;
            }
        },
        seleccionaTodo12: function(){
            if (this.selecciona_todo12 == true){
                var thisObj = this;
                this.arr_contribuciones.forEach(e => {
                    thisObj.model.contribuciones.push(e.clave);
                });
                
            } else {
                this.model.contribuciones = [];
            }
        },
        seleccionaTodo13: function(){
            if (this.selecciona_todo13 == true){
                var thisObj = this;
                this.arr_formas_pago.forEach(e => {
                    thisObj.model.formas_pago.push(e.clave);
                });
                
            } else {
                this.model.formas_pago= [];
            }
        },
        cargarReportesWS: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Contribuciones_Grafica"
            };
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datosws = res.data;
                        this.datosws.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datosws) {
                            this.datosws[k].fecha_solicitud = this.parseDate(this.datosws[k].fecha_solicitud);
                            this.datosws[k].fecha_generacion = this.parseDate(this.datosws[k].fecha_generacion);
                            this.datosws[k].estatus = this.getEstatus(this.datosws[k].estatus);
                            this.datosws[k].resultados = this.getCriterio(this.datosws[k].criterio);
                            this.datosws[k].criterio = this.getCriterioPredeterminadosWS(this.datosws[k].criterio);                            
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes ws.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getEstatus: function (estatus) {
            var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        getCriterio: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    return params.resultados;
                } 
                return null;
            } catch (error) {
                console.log(error);
                return null;
            }
        },
        getCriterioPredeterminadosWS: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    var result = "";
                    
                    result += "Año Inicial: " + params.anio_inicial + ", " + "Año Final: " + params.anio_final;
                    
                    return result +
                        ", Impo: " + (params.opc_impo == 1 ? "Si" : "No") + ", Expo: " + (params.opc_expo == 1 ? "Si" : "No") +
                        ", Contribuciones Rectificación: "+(params.contribuciones_rectificacion == 1 ? "Si" : "No");
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }
        },
        generar_reporte_sqs_ws() {
            this.verificaContribuciones();
            this.verificaFormasPago();

            if (!this.$refs.formws.validate() || this.validaForma==true || this.validaContribucion==true) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                if (this.model.opc_impo != 1)
                    this.model.opc_impo = 0;
                if (this.model.opc_expo != 1)
                    this.model.opc_expo = 0;
                if (this.model.opc_descripcion != 1)
                    this.model.opc_descripcion = 0;
                if (this.model.contribuciones_rectificacion != 1)
                    this.model.contribuciones_rectificacion = 0;
                var data = this.model;

                var data = Vue.util.extend({}, this.model); //Clonamos el modelo, para no desagrupar los filtros de contribuciones

                var contribuciones_flat = []; //Desagrupamos las contribuciones, asi se necesitan para el filtro de la api
                for (var k in this.model.contribuciones){
                    for (var m in this.model.contribuciones[k]){
                        contribuciones_flat.push(this.model.contribuciones[k][m])
                    }
                }
                data["contribuciones"] = contribuciones_flat;
                
                axios({
                        method: "post",
                        url: this.$hostname + "reportes/save_reporte/",                                                
                        data: data
                    })
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        let mensaje;
                        var titulo = "¡Operación no Permitida!";
                        var tipo = "error";
                        if (typeof error.response !== "undefined") {
                            mensaje = error.response.data.mensaje;
                            if (error.response.status == 406){
                                titulo = "¡Ya existe un reporte en proceso!";
                                tipo = "info";
                            }
                        } else {
                            mensaje = "Ocurrió un error al generar el reporte";
                        }
                        this.$swal({
                            type: tipo,
                            title: titulo,
                            text: mensaje,
                            footer: ""
                        });
                        this.$root.$dialogLoader.hide();
                    }).then(() => {
                        this.model.lista = '';
                        this.lista_filtrada = [];
                        this.cargarReportesWS();
                    });
            }
        },

        //Se deja de usar este método (getFechas), ya que el reporte solo deja máximo 1 año, solo que easí estaba en el sistema anterior
        getFechas: function () {
            var rfc = this.model.rfc
            axios.post(this.$hostname + "reportes/fechas_reporte/", {
                    'rfc': rfc
                })
                .then(response => {
                    var filtered = response.data;

                    if (filtered != null && filtered != undefined) {
                        if (String(filtered.ws_inicial) != "")
                            this.model.fecha_de = moment(String(filtered.ws_inicial)).format("YYYY-MM-DD");
                        if (String(filtered.ws_final) != "")
                            this.model.fecha_a = moment(String(filtered.ws_final)).format("YYYY-MM-DD");
                    }

                })
                .catch(error => {
                    console.log(error);
                });
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        setNombreReporteWS: function () {
            var url = this.model.reporte_url;
            var search = this.list_reportesws.filter(function (e) {
                return e.url == url;
            });
            if (search.length > 0) {
                this.model.nombre_reporte = search[0].reporte;
            }
            this.selecciona_todo12 = false;
            this.selecciona_todo13 = false;
            this.seleccionaTodo12();
            this.seleccionaTodo13();
        },
        formatNumber: function (x) {
            if (x == undefined) return 0;
            x = x.toString();
            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
            return x;
        },
                
        cargarFormasPago: function () {
            axios.post(this.$hostname+ "apendices/lista/", {tabla:5})
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        var datos = res.data;
                        datos.sort(function (a, b) {
                            //Ordenar por clave ascendente
                            return a.clave - b.clave ;
                        });
                        this.arr_formas_pago = datos;                        

                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener las formas de pago.",
                        footer: ""
                    });
                    console.log(err);
                })
        },
        cargarContribuciones: function () {
            axios.post(this.$hostname+ "apendices/lista/", {tabla:14})
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        var datos = res.data;
                        var thisObj = this;
                        datos.forEach(e => {
                            var index = 0;
                            for (var k in thisObj.arr_contribuciones){
                                if (thisObj.arr_contribuciones[k].grupo == e.grupo)
                                    index = k;
                            }
                            if (index == 0) {
                                var nombregrupo= e.clave+" - "+e.grupo;
                                if (e.clave == "5")
                                    nombregrupo= "* - IEPS";

                                thisObj.arr_contribuciones.push({"nombregrupo":nombregrupo ,"grupo":e.grupo, "clave":[e.clave], "descripcion":e.descripcion})
                            } else {
                                thisObj.arr_contribuciones[index].clave.push(e.clave);
                                thisObj.arr_contribuciones[index].descripcion+= "  **"+e.clave+" - "+e.descripcion;
                            }
                        });

                        //Se agregan incrementables manualmente
                        thisObj.arr_contribuciones.push({"nombregrupo":"Total Fletes" ,"grupo":"fletes", "clave":["fletes"], "descripcion":"Total Fletes"});
                        thisObj.arr_contribuciones.push({"nombregrupo":"Total Seguros" ,"grupo":"seguros", "clave":["seguros"], "descripcion":"Total Seguros"});
                        thisObj.arr_contribuciones.push({"nombregrupo":"Total Embalajes" ,"grupo":"embalajes", "clave":["embalajes"], "descripcion":"Total Embalajes"});
                        thisObj.arr_contribuciones.push({"nombregrupo":"Total Incrementables" ,"grupo":"incrementables", "clave":["incrementables"], "descripcion":"Total Incrementables"});  
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener las claves de contribuciones.",
                        footer: ""
                    });
                    console.log(err);
                })
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,
                }
                axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargarReportesWS();
                    });
              }
          });
        },
        getAnios: function() {
            let data = {
                rfc: this.model.rfc,                
                carpeta: "",
            };

            axios.post(this.$hostname + "reportes_ws/get_anios_pedimentos/", data)                     
                .then(res => {
                    if (typeof res.data !== "undefined") {                                                
                        this.anios = res.data;
                        this.anios.sort();
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los años de los pedimentos.",
                        footer: ""
                    });                    
                });
        },
    }, //methods
    created: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.URL = this.$hostname + "reportes/";
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.model.rfc = this.$local_storage.get("rfc");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario=="Soporte" || tipoUsuario=="Super Usuario"){
            this.permisoEliminar = true;
        }

        this.getAnios();
        this.cargarFormasPago();
        this.cargarContribuciones();
        this.cargarReportesWS();
    }
};
</script>
<style scoped>
.footer-hide>>>.VuePagination {
    display: none;
}
.elevation-1 >>> .vl {
  border-left: 1px solid gray;
  height: auto;
}
.elevation-1 >>> .v-label.theme--light {
        color: black !important;
    }
.elevation-1 >>> div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control{
    margin-bottom: -35px;
}
.elevation-1 >>> .v-input--has-state > div:nth-child(1) > div:nth-child(2){
    margin-top: -10px;
}
.elevation-1 >>> div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control div.v-input__slot label.v-label.theme--light{
    font-size: 10px !important;
}
</style>
